const CS_AND_ALLIED_BRANCHES = [
  "Artificial Intelligence & Data Science",
  "Computer Science & Engineering",
  "Information Science & Engineering",
  "Computer Science & Engineering (Artificial Intelligence & Machine Learning)",
  "Computer Science & Engineering (Cyber Security)",
  "Computer Science & Engineering(Data Science)",
  "Artificial Intelligence & Machine Learning",
  "Computer Science & Design",
  "Computer Science & Engineering(Internet of Things & Cyber Security Including Block Chain Tech)",
  "Computer Science & Engineering (Artificial Intelligence)",
  "Computer Science & Business Systems",
  "Computer Science",
  "Cyber Security",
  "Data Sciences",
  "Computer & Communication Engineering",
  "Computer Science & Engineering (Artificial Intelligence & Data Science)",
  "Computer Engineering",
  "Computer Science & Technology",
  "Computer Science & Engineering(Internet of Things)",
  "B.Tech in Computer Science & Engineering (Artificial Intelligence & Machine Learning)",
  "B.Tech in Computer Science & Engineering",
  "B.Tech in Computer Science & Engineering (Artificial Intelligence & Future Technologies)",
  "B.Tech in Information Technology",
  "B.Tech in Computer Science & Information Technology",
  "B.Tech in Computer Science & Engineering(Data Science)",
  "B.Tech in Information Science Engineering",
  "B.Tech in Computer Science & Engineering (Artificial Intelligence & Data Science)",
  "B.Tech in Computer Science & Engineering(Cyber Security)",
  "B.Tech in Computer Science & Technology",
  "B.Tech in Computer Engineering",
  "Information Science",
  "B.Tech in Computer Science",
  "B.Tech in Computer Science (Artificial Intelligence & Machine Learning)",
  "B.Tech in Computer Science (Data Science)",
  "B.Tech in Computer Science (Cloud Computing)",
  "B.Tech in Computer Science (Cyber Security)",
  "B.Tech in Computer Science (Information Security)",
  "Artificial Intelligence Engineering",
];

export default CS_AND_ALLIED_BRANCHES;
